import { Component, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SideMenuI } from '../../shared/interfaces/side-menu.interface';
import { MERCHANT_SIDE_MENU_ITEMS } from '../constants/merchant-side-menu-items';

@Component({
  selector: 'app-merchants-side-menu',
  imports: [RouterLink, RouterLinkActive, TranslateModule],
  templateUrl: './merchants-side-menu.html',
  styleUrl: './merchants-side-menu.scss',
})
export class MerchantsSideMenu {
  private readonly router = inject(Router);
  constructor() {}

  merchantSideMenuItems = MERCHANT_SIDE_MENU_ITEMS;
  currentUrl: string = this.router.url.slice(1);
  itemOnHover: string | null = null;
  isSideMenuCollapsed = signal<boolean>(true);

  ngOnInit(): void {}

  itemBeingHovered(item: string | null) {
    this.itemOnHover = item;
  }
  sideMenuItemIcon(state: boolean, item: SideMenuI) {
    return state
      ? item.activeIcon
      : this.itemOnHover === item.route
      ? item.activeIcon
      : item.inactiveIcon;
  }
}
